// extracted by mini-css-extract-plugin
module.exports = {"table":"productsTable_table__3SLBN","buttons":"productsTable_buttons__oScGG"};